var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_32_36)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0714 13.5542H26.4643V15.1373H27.2679V22.2613H13.6071V15.1373H14.4107V13.5542H12.8036C12.3616 13.5542 12 13.9104 12 14.3458V24.2402C12 24.6756 12.3616 25.0318 12.8036 25.0318H18.7902L18.4687 26.8128H16.9821C16.6607 26.8128 16.3795 27.0898 16.3795 27.4064C16.3795 27.7231 16.6607 28.0001 16.9821 28.0001H23.8125C24.1339 28.0001 24.4152 27.7231 24.4152 27.4064C24.4152 27.0898 24.1339 26.8128 23.8125 26.8128H22.3259L22.0045 25.0318H28.0714C28.5134 25.0318 28.875 24.6756 28.875 24.2402V14.3458C28.875 13.9104 28.5134 13.5542 28.0714 13.5542ZM20.4375 24.4381C20.1161 24.4381 19.8348 24.1611 19.8348 23.8444C19.8348 23.5278 20.1161 23.2508 20.4375 23.2508C20.7589 23.2508 21.0402 23.5278 21.0402 23.8444C21.0402 24.1611 20.7589 24.4381 20.4375 24.4381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9508 13H15.415V20.3219H18.9909C19.3525 20.3219 19.674 20.4011 19.9552 20.5594V13.9499C19.9552 13.4354 19.5133 13 18.9508 13ZM21.924 13C21.4016 13 20.9597 13.4354 20.9597 13.9499V20.5594C21.2409 20.4011 21.6025 20.3219 21.924 20.3219H25.4999V13H21.924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_36",
    x1: 33.5,
    y1: 5.5,
    x2: 4.5,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E78955"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.875,
    height: 15,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/SchoolIcon.31359bc2eeaa6cd96d0e99c931fd3339.svg";
export { ForwardRef as ReactComponent };